// extracted by mini-css-extract-plugin
export var container = "_69-0";
export var infoButton = "_69-1";
export var label = "_69-3";
export var labelExpanded = "_69-4";
export var price = "_69-5";
export var priceExpanded = "_69-6";
export var title = "_69-2";